/* Stylesheet */

.concept_select {
  display: flex;
  align-items: center;
  justify-content: center;

  .swiper_container {
    border-radius: 52px;
    overflow: hidden;

    .slide {
      padding: 0px 8px 0px 0px;
    }
  }
}
